import { TEST_IDS } from '@va/constants';
import { useTranslate } from '@va/localization';
import { Platform, UserRole } from '@va/types/website';
import { Paragraph, fontWeights } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { useMemo } from 'react';
import Switch from 'react-switch';

const WhiteLabelStatusCell = ({
  isEnabled,
  platform,
  userRole,
  onChange,
  disabled,
}: {
  isEnabled: boolean;
  platform: Platform;
  userRole: UserRole;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}) => {
  const translate = useTranslate();
  const isWixWebsite = platform === Platform.WIX;
  const isContributor = userRole !== UserRole.OWNER;

  const tooltipContent = useMemo(() => {
    if (!isContributor && !isWixWebsite) return;
    if (isWixWebsite) return translate('table.manageWebsites.actions.wixWhiteLabelNotAllowed');
    if (isContributor) return translate('tooltips.contributorRole');
  }, [isContributor, isWixWebsite, translate]);

  if (isContributor)
    return (
      <TooltipWrapper content={translate('standalone.contributors.accessInformationNotice')}>
        <Paragraph weight={fontWeights.medium}>{translate('standalone.contributors.noAccessRights')}</Paragraph>
      </TooltipWrapper>
    );

  return (
    <div className='flex items-center'>
      <TooltipWrapper content={tooltipContent} disabled={!tooltipContent}>
        <div className='flex items-center'>
          <Switch
            handleDiameter={24}
            offHandleColor='#FFFFFF'
            onHandleColor={'#FFFFFF'}
            offColor='#C3C3C3'
            onColor={'#06A25A'}
            onChange={onChange}
            checked={isEnabled}
            checkedIcon={false}
            uncheckedIcon={false}
            width={48}
            height={30}
            disabled={isWixWebsite || isContributor || disabled}
            data-testid={TEST_IDS.generic.whiteLabel.toggleWhiteLabelSwitch}
          />
        </div>
      </TooltipWrapper>
      <span className='ml-4 font-medium text-15 leading-normal text-gray-devil'>
        {translate(isEnabled ? 'option.btn.enabled' : 'option.btn.disabled')}
      </span>
    </div>
  );
};

export default WhiteLabelStatusCell;
